/* eslint-disable react-hooks/exhaustive-deps */
// @vendors
import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

// @components
import ServiceCard from "./ServiceCard";
import { NoServiceMessage } from "./NoServiceMessageCard";

// @types
import { ServiceRequest } from "../../../types/request.types";
import routesConfig from "../../../config/routes.config";

export const ActiveServices: React.FC<{ services: ServiceRequest[] | null }> = ({ services }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleRequestServiceClick = () => navigate("/categories");

  const handleServiceClick = (service: ServiceRequest) => {
    navigate(`${routesConfig.serviceDetail}${service.serviceRequestId}`, { state: { service } });
  };

  return (
    <section>
      <h2 className="text-[15px] font-semibold mb-4">{t("myServices.activeService")}</h2>
      <div className="w-full flex gap-8 bg-cBackgroundSecondary dark:bg-dark-cBackgroundSecondary rounded-lg p-5">
        {services?.length === 0 ? (
          <NoServiceMessage
            title={t("myServices.noServiceMessage.title")}
            messageOne={t("myServices.noServiceMessage.messageOne")}
            messageTwo={t("myServices.noServiceMessage.messageTwo")}
            buttonText={t("myServices.noServiceMessage.requestButton")}
            onClick={handleRequestServiceClick}
          />
        ) : (
          <div className="flex flex-col xl:flex-row justify-between w-full gap-8">
            <div className="w-full flex flex-col gap-[10px] overflow-auto">
              {services?.map((servicio: ServiceRequest) => (
                <ServiceCard
                  key={servicio.serviceRequestId}
                  service={servicio}
                  onClick={() => handleServiceClick(servicio)}
                />
              ))}
            </div>
            <NoServiceMessage
              messageOne={t("myServices.noServiceMessage.messageOne")}
              messageTwo={t("myServices.noServiceMessage.messageTwo")}
              buttonText={t("myServices.noServiceMessage.requestButton")}
              onClick={handleRequestServiceClick}
            />
          </div>
        )}
      </div>
    </section>
  );
};

export default ActiveServices;
